import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#1E293B', contrastText: '#fff' }, // Brand navy
    secondary: { main: '#38BDF8', contrastText: '#fff' }, // Brand accent
    background: { default: '#FAFAFA', paper: '#fff' }, // Brand bg, card
    text: {
      primary: '#1E293B',
      secondary: '#178046',
      disabled: '#8CA1A5',
    },
    success: { main: '#17B046' },
    info: { main: '#178046' },
    divider: '#E0E6ED',
    footer: { main: '#1E293B', contrastText: '#F1F5F9' },
    movdLight: { main: '#F1F5F9' },
  },
  typography: {
    fontFamily: 'Inter, Roboto, Poppins, Arial, sans-serif',
    h1: { fontWeight: 700, letterSpacing: 0.5 },
    h2: { fontWeight: 700, letterSpacing: 0.5 },
    h3: { fontWeight: 700, letterSpacing: 0.5 },
    h4: { fontWeight: 700, letterSpacing: 0.5 },
    h5: { fontWeight: 700, letterSpacing: 0.5 },
    h6: { fontWeight: 700, letterSpacing: 0.5 },
    button: { textTransform: 'none', fontWeight: 700, letterSpacing: 0.2 },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 500 },
    body1: { fontWeight: 400 },
    body2: { fontWeight: 400 },
  },
  shape: {
    borderRadius: 16, // match --movd-radius
  },
  shadows: [
    'none',
    '0 2px 12px #1e293b0a', // match --movd-shadow
    ...Array(23).fill('0 2px 12px #1e293b0a'),
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          fontWeight: 700,
          fontSize: 16,
          backgroundColor: '#38BDF8',
          color: '#fff',
          boxShadow: '0 2px 8px #38bdf81a',
          padding: '10px 28px',
          '&:hover': {
            backgroundColor: '#0ea5e9',
            color: '#fff',
          },
          textTransform: 'none',
        },
        contained: {
          backgroundColor: '#38BDF8',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#0ea5e9',
            color: '#fff',
          },
        },
        outlined: {
          borderColor: '#38BDF8',
          color: '#38BDF8',
          '&:hover': {
            backgroundColor: '#E6F7F0',
            borderColor: '#0ea5e9',
            color: '#0ea5e9',
          },
        },
        text: {
          color: '#38BDF8',
          '&:hover': {
            backgroundColor: '#E6F7F0',
            color: '#0ea5e9',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 2px 12px #1e293b0a',
          backgroundColor: '#fff',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          backgroundColor: '#fff',
          boxShadow: '0 2px 12px #1e293b0a',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          fontWeight: 600,
          backgroundColor: '#F1F5F9',
          color: '#1E293B',
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1E293B',
          color: '#fff',
          fontWeight: 700,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#1E293B',
          fontWeight: 600,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          backgroundColor: '#F1F5F9',
        },
        notchedOutline: {
          borderColor: '#e2e8f0',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          backgroundColor: '#F1F5F9',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          fontWeight: 500,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#1E293B',
          color: '#fff',
          borderRadius: 0,
          boxShadow: '0 2px 12px #1e293b0a',
        },
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: {
          backgroundColor: '#1E293B',
          color: '#F1F5F9',
          borderRadius: 0,
        },
      },
    },
  },
  demoMoverImages: [
    '/assets/img/property/01.jpg',
    '/assets/img/property/02.jpg',
    '/assets/img/property/03.jpg',
    '/assets/img/property/04.jpg',
  ],
});

export default theme;
